import { gql } from '@apollo/client';

export const Register = gql`
    mutation register(
        $companyName: String!
        $email: String!
        $firstName: String!
        $lastName: String!
        $phoneNumber: String!
        $password1: String!
        $password2: String!
        $recaptchaCode: String!
    ) {
        register(
            companyName: $companyName
            email: $email
            firstName: $firstName
            lastName: $lastName
            password1: $password1
            password2: $password2
            phoneNumber: $phoneNumber
            recaptchaCode: $recaptchaCode
        ) {
            ... on SuccessType {
                message
            }

            ... on ErrorType {
                message
            }
        }
    }
`;
